import React from 'react';
import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        {/* Brand row */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '3rem', marginBottom: '4rem', flexWrap: 'wrap' }}>

          {/* Brand column */}
          <div className="footer-brand">
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
              {/* Botanical leaf SVG matching header */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="28"
                height="28"
                aria-hidden="true"
                style={{ flexShrink: 0 }}
              >
                <path
                  d="M24 4C13 4 5 14 5 26c0 10 6.5 17 13 19 0-8 3-14 6-18-1 6-1 12 1 18
                     6-2 13-9 13-19C38 14 35 4 24 4z"
                  fill="var(--primary-color)"
                />
              </svg>
              <span style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: '1.5rem',
                fontWeight: '700',
                color: 'var(--primary-color)'
              }}>
                Nouria
              </span>
            </div>
            <p style={{ color: 'var(--text-secondary)', lineHeight: '1.7', fontSize: '0.95rem', marginBottom: '1.5rem' }}>
              A calm, AI-powered sanctuary for sustainable gut health and mindful fasting.
              Cultivating wellness from within — one mindful meal at a time.
            </p>
            <a href="mailto:support@nouria.fit" className="footer-email">
              support@nouria.fit
            </a>
          </div>

          {/* Explore column */}
          <div>
            <p style={{
              fontSize: '0.75rem',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
              color: 'var(--text-light)',
              marginBottom: '1.25rem'
            }}>
              Explore
            </p>
            <nav className="footer-nav" style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
              <Link to="/">Home</Link>
              <Link to="/professionals">For Professionals</Link>
              <Link to="/blogs">Journal</Link>
              <Link to="/tools">Free Tools</Link>
              <Link to="/help">Help Center</Link>
            </nav>
            <div style={{ marginTop: '1.5rem' }}>
              <p style={{
                fontSize: '0.75rem',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '0.12em',
                color: 'var(--text-light)',
                marginBottom: '0.75rem'
              }}>
                Get The App
              </p>
              <a
                href="https://play.google.com/store/apps/details?id=com.masalachailabs.nouria"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Download Nouria from Google Play Store"
                className="footer-play-store-link"
              >
                <img
                  src="/google-play-badge-en.webp"
                  alt="Get it on Google Play"
                  style={{ height: '48px', width: 'auto', display: 'block', transition: 'transform 0.25s ease' }}
                  className="play-store-badge-hover"
                />
              </a>
            </div>
          </div>

          {/* Legal + Social column */}
          <div>
            <p style={{
              fontSize: '0.75rem',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
              color: 'var(--text-light)',
              marginBottom: '1.25rem'
            }}>
              Legal
            </p>
            <nav className="footer-nav" style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem', marginBottom: '2rem' }}>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/delete-account">Delete Account</Link>
            </nav>

            <p style={{
              fontSize: '0.75rem',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
              color: 'var(--text-light)',
              marginBottom: '1rem'
            }}>
              Follow the Journey
            </p>
            <SocialLinks />
          </div>

        </div>

        {/* Divider */}
        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '2rem', textAlign: 'center' }}>
          <p style={{ color: 'var(--text-light)', fontSize: '0.875rem' }}>
            &copy; {new Date().getFullYear()} Nouria &nbsp;&middot;&nbsp; All Rights Reserved
            &nbsp;&middot;&nbsp; Made with 🌿 for gut health enthusiasts everywhere.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
